import { SCENES_MAP } from 'consts';
import { ROUTE_MAP } from 'consts/url';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateWorldParams } from 'store/actions';

// Built on every call (not at import time) so scenes registered after the tour
// data loads are routable too.
const getPathAdapter = () => ({
  [`/${ROUTE_MAP.overview.id}`]: {
    sceneId: '68e768a4fa4f187e528e21c2',
  },
  ...Object.entries(SCENES_MAP).reduce((acc, [sceneId, { url }]) => {
    acc[url] = { sceneId };
    return acc;
  }, {}),
});

export const useInitPage = (pathname) => {
  const dispatch = useDispatch();

  const { sceneId = '' } = getPathAdapter()[pathname] || {};

  console.log('Initializing page with sceneId:', sceneId);

  useEffect(() => {
    if (sceneId) {
      dispatch(
        updateWorldParams({
          sceneId,
        })
      );
    }
  }, [dispatch, sceneId]);

  return { sceneId };
};
